import React from 'react';
import { Link } from 'react-router-dom';
import { User, Heart, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../context/FavoritesContext';
import { LOGO_LIGHT } from '../data/constants';

const Header = () => {
  const { setIsCartOpen, getCartCount } = useCart();
  const { setIsLoginModalOpen, user } = useAuth();
  const { getFavoritesCount } = useFavorites();

  const cartCount = getCartCount();
  const favoritesCount = getFavoritesCount();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/20 dark:border-white/10">
      <div className="max-w-[1920px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Left - Profile */}
          <div className="flex items-center gap-2 w-1/3">
            <button
              onClick={() => user ? window.location.href = '/profile' : setIsLoginModalOpen(true)}
              className="p-2 hover:bg-brand-accent/5 dark:hover:bg-brand-surface/10 rounded-xl transition-colors"
              aria-label="Профиль"
            >
              <User className="w-5 h-5 md:w-6 md:h-6 text-brand-text dark:text-brand-text" strokeWidth={1.5} />
            </button>
          </div>

          {/* Center - Logo */}
          <div className="flex justify-center w-1/3">
            <Link to="/" className="flex items-center">
              <img
                src={LOGO_LIGHT}
                alt="TI STORE"
                className="h-auto w-[112px] md:w-[150px] max-w-full object-contain"
              />
            </Link>
          </div>

          {/* Right - Favorites & Cart */}
          <div className="flex items-center justify-end gap-2 md:gap-3 w-1/3">
            <Link
              to="/favorites"
              className="p-2 hover:bg-brand-accent/5 dark:hover:bg-brand-surface/10 rounded-xl transition-colors relative"
              aria-label="Избранное"
            >
              <Heart className="w-5 h-5 md:w-6 md:h-6 text-brand-text dark:text-brand-text" strokeWidth={1.5} />
              {favoritesCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text text-xs rounded-full flex items-center justify-center font-medium">
                  {favoritesCount}
                </span>
              )}
            </Link>
            <button
              onClick={() => setIsCartOpen(true)}
              className="p-2 hover:bg-brand-accent/5 dark:hover:bg-brand-surface/10 rounded-xl transition-colors relative"
              aria-label="Корзина"
            >
              <ShoppingBag className="w-5 h-5 md:w-6 md:h-6 text-brand-text dark:text-brand-text" strokeWidth={1.5} />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-brand-accent dark:bg-brand-accent text-brand-text dark:text-brand-text text-xs rounded-full flex items-center justify-center font-medium">
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
